export default "__VITE_ASSET___eFwdhYe__"